import React from "react";
import "./pagination.css";
import { BsArrowRight, BsArrowLeft } from "react-icons/bs";

type PaginationProps = {
  count: number;
  currentPage: number;
  itemsPerPage: number;
  onPageChange: (pageNumber: number) => void;
};

const Pagination: React.FC<PaginationProps> = ({
  count,
  currentPage,
  itemsPerPage,
  onPageChange,
}) => {
  const getPaginationRange = (
    currentPage: number,
    totalPages: number
  ): (number | "...")[] => {
    const range: (number | "...")[] = [];
    const maxVisiblePages = 5;

    if (totalPages <= maxVisiblePages) {
      for (let i = 1; i <= totalPages; i++) {
        range.push(i);
      }
    } else {
      range.push(1);

      if (currentPage > 3) {
        range.push("...");
      }

      const startPage = Math.max(2, currentPage - 1);
      const endPage = Math.min(totalPages - 1, currentPage + 1);

      for (let i = startPage; i <= endPage; i++) {
        range.push(i);
      }

      if (currentPage < totalPages - 2) {
        range.push("...");
      }

      range.push(totalPages);
    }

    return range;
  };

  const totalPages = Math.ceil(count / itemsPerPage);

  if (totalPages <= 1) {
    return null;
  }

  return (
    <div className="pagination-bar">
      <button
        type="button"
        className="pagination-btn pagination-btn--nav"
        disabled={currentPage === 1}
        onClick={() => onPageChange(currentPage - 1)}
      >
        <BsArrowLeft />
        <span>Previous</span>
      </button>

      <div className="pagination-pages">
        {getPaginationRange(currentPage, totalPages).map((pageNum, index) =>
          pageNum === "..." ? (
            <span key={`dots-${index}`} className="pagination-dots">
              ...
            </span>
          ) : (
            <button
              type="button"
              key={`page-${pageNum}`}
              className={`pagination-btn pagination-btn--page${
                currentPage === pageNum ? " pagination-btn--active" : ""
              }`}
              onClick={() => onPageChange(pageNum as number)}
              disabled={currentPage === pageNum}
            >
              {pageNum}
            </button>
          )
        )}
      </div>

      <button
        type="button"
        className="pagination-btn pagination-btn--nav"
        disabled={currentPage === totalPages}
        onClick={() => onPageChange(currentPage + 1)}
      >
        <span>Next</span>
        <BsArrowRight />
      </button>
    </div>
  );
};

export default Pagination;
